import { useState } from 'react';
import { useSelector } from 'react-redux';
import { AccessTime, Description } from '@mui/icons-material';
import PersonalInfo from './PersonalInfo';
import AddTaxInvoiceDetails from './AddTaxInvoiceDetails';
import KycVerification from './KycVerification';
import AlertCarousel from '../../../../../components/carousel/AlertCarousel';

function MyProfile() {
    const user = useSelector((state) => state.auth.user);

    const [openPopup, setOpenPopup] = useState({
        open: false,
        popupType: 'KYC_VERIFICATION'
    });

    const banners = [];

    // Conditionally add tax invoice details banner if user's address is null
    if (!user?.verification?.pan_number || !user?.address) {
        banners.push({
            id: banners.length + 1, // Ensure unique IDs
            bannerText: 'Add tax invoice details',
            buttonText: 'Add Details',
            onClick: () => setOpenPopup({ open: true, popupType: 'ADD_TAX_INVOICE_DETAILS' }),
            icon: <Description color="secondary" sx={{ fontSize: '1rem' }} />
        });
    }


    // Conditionally add KYC banner if user's aadhar_number is null
    // if (!user?.verification?.aadhar_number) {
    //     banners.push({
    //         id: 1,
    //         bannerText: 'KYC verification is pending',
    //         buttonText: 'Verify',
    //         icon: <AccessTime color="secondary" sx={{ fontSize: '1rem' }} />,
    //         onClick: () => setOpenPopup({ open: true, popupType: 'KYC_VERIFICATION' })
    //     });
    // }

    return (
        <div className="user-profile-main-container">
            {banners.length > 0 && <AlertCarousel banners={banners} />}

            <div className="user-profile-container">
                {!openPopup.open && <PersonalInfo />}
            </div>

            {openPopup.open && openPopup.popupType === 'ADD_TAX_INVOICE_DETAILS' && (
                <AddTaxInvoiceDetails
                    onClose={() =>
                        setOpenPopup({ open: false, popupType: 'ADD_TAX_INVOICE_DETAILS' })
                    }
                />
            )}

            {openPopup.open && openPopup.popupType === 'KYC_VERIFICATION' && (
                <KycVerification
                    onClose={() => setOpenPopup({ open: false, popupType: 'KYC_VERIFICATION' })}
                />
            )}
        </div>
    );
}

export default MyProfile;